import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PropertiesCountry } from '../../interfaces/countries';
import { PropertiesCityDetails } from '../../interfaces/city';
import { ICities } from '../../interfaces/cities';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { IResponseData } from '../../interfaces/response-data';
import { languages } from '../../../constants/language.constants';
import { ICityWithImages } from '../../interfaces/cityWithImages';

@Injectable({
  providedIn: 'root'
})
export class CitiesService {
  countriesList: Observable<PropertiesCountry[]>;

  constructor(private readonly http: HttpClient) {
    this.countriesList = this.getCountriesList();
  }

  countries(): Observable<PropertiesCountry[]> {
    return this.countriesList;
  }

  cities(): Observable<PropertiesCityDetails[]> {
    return this.countriesList.pipe(
      map((countries) => {
        const cities: PropertiesCityDetails[] = [];
        countries.forEach((country) => {
          country.cities.forEach((city) => {
            if (!country.name) {
              country.name = {
                [languages.en]: country.code
              };
            }
            cities.push({
              id: city.id,
              city: city.name,
              country: country.name,
              code: country.code?.toLowerCase(),
              property_count: Number(city.property_count)
            });
          });
        });
        return cities;
      })
    );
  }

  getCountriesList(): Observable<PropertiesCountry[]> {
    return this.http.get<PropertiesCountry[]>(`${environment.apiBaseUrl}/cities/countries-list`).pipe(shareReplay(1));
  }

  getCityImagesById(cityId: number): Observable<IResponseData<ICityWithImages>> {
    return this.http.get<IResponseData<ICityWithImages>>(`${environment.apiBaseUrl}/public/cities/${cityId}`);
  }

  getCitiesList(): Observable<IResponseData<ICities[]>> {
    return this.http.get<IResponseData<ICities[]>>(`${environment.apiBaseUrl}/cities`);
  }
}
